module.exports = __webpack_public_path__ + "static/media/ic-alert.c7ffa4c4.svg";